<template>
  <div class="page">
    <div class="app-container">
      <!-- 用 isPrivacy 字段区分报价员岗位，对报价员权限做出限制，非报价员不做限制 -->
      <BaseSearch v-model="searchData" :formOptions="searchFormOption" @handleSearch="handleSearch" v-if="!isPrivacy">
      </BaseSearch>
      <!-- 限制权限 -->
      <BaseSearch v-model="searchData" :formOptions="searchFormOption_privacy" @handleSearch="handleSearch" :searchNotNull="false" v-else>
      </BaseSearch>
      <el-button type="primary" @click="handleCall"><i></i> 查看通话中记录</el-button>

      <!-- 用 isPrivacy 字段区分报价员岗位，对报价员权限做出限制，非报价员不做限制 -->
      <BaseTable ref="baseTable" url="/admin/customer/index" :tableData.sync="tableData" :columns="columns" v-if="!isPrivacy"
        :searchParams="searchData" :privacyColumns="privacyColumns">
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="insbill(row)">算价</el-button>
          <el-button type="text" size="mini" @click="insbillList(row)">算价记录</el-button>
        </template>
      </BaseTable>
      <!-- 限制权限 -->
      <BaseTable ref="baseTable" url="/admin/customer/index" :tableData.sync="tableData" :columns="columns_privacy" v-else
        :searchParams="searchData" :privacyColumns="privacyColumns" :isInitSearch="false">
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="insbill(row)">算价</el-button>
          <el-button type="text" size="mini" @click="insbillList(row)">算价记录</el-button>
        </template>
      </BaseTable>

      <!-- 查询通话中记录 -->
      <el-dialog title="通话中记录" :visible.sync="dialogCall" width="70%" @close="dialogCall = false">
        <el-table :data="callTableDataPrivacy" :stripe="true" :border="true">
          <el-table-column prop="username" label="客户名称" align="center" :formatter="idCardFormatter"></el-table-column>
          <el-table-column prop="tel" label="客户电话" align="center"></el-table-column>
          <el-table-column prop="idCard" label="身份证号" align="center"></el-table-column>
          <el-table-column prop="address" label="地址" align="center"></el-table-column>
          <el-table-column prop="carNo" label="车牌号" align="center"></el-table-column>
          <el-table-column prop="vin" label="车架号" align="center"></el-table-column>
          <el-table-column prop="engine" label="发动机号" align="center"></el-table-column>
          <el-table-column prop="nature" label="车辆性质" align="center"></el-table-column>
          <el-table-column prop="model" label="车型" align="center"></el-table-column>
          <el-table-column prop="carBeginDate" label="初登日期" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope">
              <el-button type="text" size="mini" @click="insbill_p(scope.row)">算价</el-button>
              <el-button type="text" size="mini" @click="insbillList(scope.row)">算价记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { columns } from "./columns";
import { columns_privacy } from "./columns_privacy";
import { searchFormOption } from "./formOptions";
import { searchFormOption_privacy } from "./formOptions_privacy";

export default {
  name: "Customer",
  comments: {},
  data() {
    return {
      tableData: [],
      formData: {},
      searchData: {},
      dialogCall: false,
      callTableData: [],
      callTableDataPrivacy: [],
      privacyColumns: [],
      isPrivacy: this.$store.state.user.group_id == 17,   // 账号等级，17为报价员，需要做数据隐私处理
    };
  },
  computed: {
    columns,
    columns_privacy,
    searchFormOption,
    searchFormOption_privacy
  },
  created() { 
    this.columns.forEach(item => {
      if (item.privacyType && item.privacyType == true) {
        this.privacyColumns.push(item.prop);
      }
    });

    this.columns_privacy.forEach(item => {
      if (item.privacyType && item.privacyType == true) {
        this.privacyColumns.push(item.prop);
      }
    });
  },
  methods: {
    insbill(row) {
      console.log(row);
      
      this.$api.post(
        "/admin/customer/addCustomer",
        {
          customerId: row.customerId,
          username: row.username,
          tel: row.tel,
          address: row.address,
          carNo: row.carNo,
          vin: row.vin
        },
      ).then((res) => {
        if (res.id == 0 || res.id == '') {
          this.$message.warning("客户信息添加失败，请重试");
          return;
        }
        // 车牌号 填充规则 暂+车架号后6位
        let carNo = row.carNo;
        if ((row.vin && carNo == '') || carNo == null || carNo == 'null') {
          carNo = '暂' + row.vin.slice(-6);
        }
        this.$router.push({
          path: "/issue/recording",
          query: {
            isCustomer: 1,
            carNo: carNo,
            vin: row.vin,
            engineNo: row.engine,
            beginDate: row.carBeginDate,
            brandType: row.model,
            usetype: row.nature || '',
            personName: row.username,
            certNo: row.idCard,
            tel: row.tel,
            addr: row.address
          },
        });

        // 本地存储参数
        // this.$store.commit("app/SET_ROUTE_PARAMS", {
        //   isCustomer: 1,
        //   carNo: carNo,
        //   vin: row.vin,
        //   engineNo: row.engine,
        //   beginDate: row.carBeginDate,
        //   brandType: row.model,
        //   usetype: row.nature || '',
        //   personName: row.username,
        //   certNo: row.idCard,
        //   tel: row.tel,
        //   addr: row.address
        // });
        // console.log('state====',this.$store.state.app);
        
      });
    },

    insbill_p(row) {
      let r
      this.callTableData.map(item => {
      if(item.tel == row.tel){
        r = item;
      }
      });
      this.insbill(r)
    },

    // 查看通话中的记录
    async handleCall() {
      const res = await this.$api.post("/admin/customer/index", { isCall: 1 });
      this.callTableData = res.data.data;

      let p = JSON.parse(JSON.stringify(res.data.data))
      this.callTableDataPrivacy = p.map(item => {
        if(item) {
          for (const key in item) {
            if(key != 'tel') {
              item[key] = "";
            }
          }
        }
        return item;
      })

      this.dialogCall = true;
    },
    insbillList(row) {
      this.$router.push({
        path: "/issue/search",
        query: {
          vin: row.vin,
        },
      });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    idCardFormatter(row, column, cellValue) {
      return cellValue.replace(/^(.{6})(.*)(.{4})$/, '$1****$3');
    },
  },
};
</script>
